// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class FloatValue implements flatbuffers.IUnpackableObject<FloatValueT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): FloatValue {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsFloatValue(bb: flatbuffers.ByteBuffer, obj?: FloatValue): FloatValue {
    return (obj || new FloatValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsFloatValue(bb: flatbuffers.ByteBuffer, obj?: FloatValue): FloatValue {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new FloatValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  value(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
  }

  static startFloatValue(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addValue(builder: flatbuffers.Builder, value: number) {
    builder.addFieldFloat32(0, value, 0.0);
  }

  static endFloatValue(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createFloatValue(builder: flatbuffers.Builder, value: number): flatbuffers.Offset {
    FloatValue.startFloatValue(builder);
    FloatValue.addValue(builder, value);
    return FloatValue.endFloatValue(builder);
  }

  unpack(): FloatValueT {
    return new FloatValueT(this.value());
  }

  unpackTo(_o: FloatValueT): void {
    _o.value = this.value();
  }

  unpackFields(...fields: string[]): FloatValueT {
    const t = new FloatValueT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("value")) {
      t.value = this.value();
    }
    return t;
  }
}

export class FloatValueT implements flatbuffers.IGeneratedObject {
  constructor(public value: number = 0.0) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return FloatValue.createFloatValue(builder, this.value);
  }

  clone(): FloatValueT {
    const obj = new FloatValueT();
    obj.value = this.value;
    return obj;
  }

  equals(other: FloatValueT): boolean {
    if (!Object.is(this.value, other.value)) return false;
    return true;
  }
}

export function verifyFloatValue(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 4);
  } finally {
    verifier.popDepth();
  }
}
